export default {
    'ERROR-SEND-LOGIN': {
        'USER-NOT-ADMIN-PROSPECT-AMBASSADOR': {
            actionType: 'toast',
            message: {
                fr: "Aucun compte correspondant trouvé avec cet email.",
                en: 'No matching account found with this email.',
            },
        },
        'USER-NO-PERSONA': {
            actionType: 'toast',
            message: {
                fr: "Erreur lors de la sélection du type d'utilisateur.",
                en: 'Error selecting user persona.',
            },
        },
    },
};
